export const feedbackData = [
    {id:0, value:60, label: 'I like it', color:'#4CAF50'}, 
    {id:1, value:10, label: 'I am not decided', color: '#7A5EE4'}, 
    {id:2, value:5, label: 'I don\'t like it', color: '#F8BC16'}
]

export const likeAvatars = {
        'City':
            [
                {id:0, value:18, label: 'Riyadh (Riyadh Region)', color:'#4CAF50'}, 
                {id:1, value:10, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:13, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:2, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:4, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:12, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:5, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:33, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:3, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:12, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:3, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:1, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:12, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:13, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:2, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:5, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:14, label: '5,000 SAR - 10,000 SAR', color:'#4CAF50'}, 
                {id:1, value:2, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:16, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:24, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:33, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:3, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:41, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:4, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:21, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:2, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:15, label: 'ELECTRONICS', color:'#4CAF50'}, 
            {id:1, value:22, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:41, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:5, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:20, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:9, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:33, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:2, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:16, label: '50 SAR - 200 SAR', color:'#4CAF50'}, 
            {id:1, value:3, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:25, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:28, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:8, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:15, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:8, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:15, label: 'SHOPS', color:'#4CAF50'}, 
            {id:1, value:25, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:4, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:22, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:16, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }

export const notDecidedAvatars = {
        'City':
            [
                {id:0, value:3, label: 'Riyadh (Riyadh Region)', color:'#4CAF50'}, 
                {id:1, value:17, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:23, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:4, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:6, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:3, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:22, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:5, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:3, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:22, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:9, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:21, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:15, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:5, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:33, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:4, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:3, label: '5,000 SAR - 10,000 SAR', color:'#4CAF50'}, 
                {id:1, value:15, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:14, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:16, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:35, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:14, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:25, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:19, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:12, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:5, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:26, label: 'ELECTRONICS', color:'#4CAF50'}, 
            {id:1, value:15, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:29, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:12, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:4, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:12, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:20, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:19, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:4, label: '50 SAR - 200 SAR', color:'#4CAF50'}, 
            {id:1, value:19, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:5, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:14, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:12, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:14, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:2, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:44, label: 'SHOPS', color:'#4CAF50'}, 
            {id:1, value:2, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:5, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:7, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:10, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }

export const dontLikeAvatars = {
        'City':
            [
                {id:0, value:13, label: 'Riyadh (Riyadh Region)', color:'#4CAF50'}, 
                {id:1, value:24, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:23, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:24, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:3, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:24, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:3, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:23, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:12, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:37, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:9, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:5, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:2, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:15, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:12, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:7, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:13, label: '5,000 SAR - 10,000 SAR', color:'#4CAF50'}, 
                {id:1, value:5, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:4, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:36, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:18, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:2, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:17, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:3, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:10, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:4, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:13, label: 'ELECTRONICS', color:'#4CAF50'}, 
            {id:1, value:29, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:24, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:7, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:21, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:43, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:15, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:3, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:19, label: '50 SAR - 200 SAR', color:'#4CAF50'}, 
            {id:1, value:33, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:15, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:13, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:5, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:2, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:2, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:30, label: 'SHOPS', color:'#4CAF50'}, 
            {id:1, value:2, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:3, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:4, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:2, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }